var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":null,"visible":!!_vm.visible,"wrapClassName":"demo__AuthModal--con","dialogClass":"demo__AuthModal","footer":null,"mask":false},on:{"cancel":function($event){return _vm.$store.dispatch('updateAuthModalStatus', false)}}},[_c(_vm.authModalStatusCache,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }